





















































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import {
  GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_mostRecentAmeldingReconciliationReports,
} from "@/queries/__generated__/ameldingAndBookkeepingReconciliationReport";
import AmeldingReconciliationReportList from "./AmeldingReconciliationReportList.vue";
import gql from 'graphql-tag';

const UPLOAD_AMELDING_RECONCILIATION_REPORTS = gql`
  mutation uploadAmeldingReconciliationReport(
    $unitId: ID!,
    $files: [FileUpload!]!,
  ) {
    uploadAmeldingReconciliationReport(
      input: {
        unitId: $unitId,
        files: $files,
      }
    ) {
      reports {
        id
      }
    }
  },
`;

@Component({
  components: {
    AmeldingReconciliationReportList,
  },
})
export default class AmeldingReconciliationReport extends Vue {
  private receivedNewReports = false;
  @Prop({ type: Number, required: true }) private year!: number;
  @Prop(Object) private status!: GQL_ameldingAndBookkeepingReconciliationReport_ameldingAndBookkeepingReconciliationReport_mostRecentAmeldingReconciliationReports;
  @SmartQuery<AmeldingReconciliationReport, GQL_currentUnit>({
    query: CURRENT_UNIT,
  }) public currentUnit!: GQL_currentUnit_currentUnit;

  private translate(key: string) {
    return this.$t(`PaycheckReport.AmeldingAndBookkeepingReconciliation.AmeldingReconciliationReport.${key}`);
  }

  private UPLOAD_MUTATION = UPLOAD_AMELDING_RECONCILIATION_REPORTS;
  private files = [];
  private openFetchForm = false;

  @Emit('new-altinn-status-reports')
  private uploaded(){
    this.receivedNewReports = true;
    this.openFetchForm = false;
    this.files = [];
  }
}
